module.exports = __webpack_public_path__ + "media/assets/icons/law-02891f12eba020f13c218261f168d282.svg";